import { useState, useMemo } from "react";
import Layout from "../../../components/global/Layout";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowLeft,
  faArrowRight,
  faSearch,
} from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import CardSkeleton from "../../../components/global/card/CardSkeleton/CardSkeleton";
import CardBook from "../../../components/global/card/CardBook/CardBook";
import Paginator from "react-hooks-paginator";
import { fetcher } from "../../../utils/fetcher";
import useSWR from "swr";

const BukuSTEM = () => {
  const [filters, setFilters] = useState({
    type: "semua", // default semua
    title: "",
  });

  const [activeFilters, setActiveFilters] = useState(filters);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageLimit, setPageLimit] = useState(24);
  const [offset, setOffset] = useState(0);

  const handleTypeChange = (type) => {
    const newFilters = { ...filters, type, title: "" };
    setFilters(newFilters);
    setActiveFilters(newFilters);
    setCurrentPage(1);
  };

  const handleSearchClick = () => {
    setCurrentPage(1);
    setActiveFilters(filters);
  };

  const endpointUrl = useMemo(() => {
    let BASE_URL = "";

    if (filters.type === "semua" || filters.type === "pelajaran") {
      BASE_URL = `https://api.buku.cloudapp.web.id/api/catalogue/getBooksByTag?tag=STEM`;
    } else if (filters.type === "umum") {
      BASE_URL = `https://api.buku.cloudapp.web.id/api/catalogue/getNonTextBooks?tag=STEM&limit=100`;
    }

    const params = new URLSearchParams({
      page: currentPage,
      limit: pageLimit,
    });

    const { type, ...otherFilters } = activeFilters;

    Object.keys(otherFilters).forEach((key) => {
      if (otherFilters[key]) {
        params.append(key, otherFilters[key]);
      }
    });

    return `${BASE_URL}&${params.toString()}`;
  }, [activeFilters, currentPage]);

  const { data, error, isLoading } = useSWR(endpointUrl, fetcher, {
    revalidateOnFocus: false,
    keepPreviousData: true,
  });

  const books = data?.results || [];
  const totalRecords = data?.pagination?.total_items || 0;

  const scrollTop = () => {
    document.getElementById("catalog")?.scrollIntoView();
  };

  useMemo(() => {
    scrollTop();
  }, [currentPage]);

  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <Layout>
      <section id="catalog">
        <div className="container px-3 py-5">
          <div className="row justify-content-center">
            <div className="col-lg-9">
              <div className="row">
                <div className="col-12 col-lg-12 position-relative">
                  <h3 className="mb-2">Buku Bermuatan STEM</h3>
                  <h5 className="mb-3"><span className="text-danger">Sains</span>, <span className="text-warning">Technology</span>, <span className="text-success">Engineering</span>, dan <span className="text-info">Mathematics</span></h5>
                 
                  <div class="mb-3" style={{ fontSize: '16px', background: '#f0f0f0', padding: '10px', borderRadius: '5px' }}>
                    <div className="mb-3">
                      <b>Selamat Datang di Koleksi Buku Bermuatan dan Pendukung Pembelajaran STEM!</b>
                    </div>
                    
                    <div className="row">
                      <div className="col">
                        <p style={{ textAlign: 'justify' }}>
                          STEM (<i>Science</i>, <i>Technology</i>, <i>Engineering</i>, dan <i>Mathematics</i>) adalah
                          pendekatan belajar yang menggabungkan sains, teknologi, rekayasa, dan matematika untuk memecahkan masalah nyata dalam kehidupan sehari-hari.
                        </p>
                        
                        {isExpanded && (
                          <>
                            <p style={{ textAlign: 'justify' }}>
                              Melalui STEM, kita diajak berpikir kritis, berkreasi, dan berkolaborasi lintas disiplin ilmu dan semuanya dilakukan secara kontekstual.
                            </p>
                            
                            <p style={{ textAlign: 'justify' }}>
                              Koleksi yang tersedia mencakup berbagai pilihan buku, mulai dari buku teks (buku teks utama dan buku teks pendamping) hingga buku nonteks (bacaan pengayaan, fiksi, maupun nonfiksi). Buku-buku ini memuat komponen-komponen yang mendukung pembelajaran STEM. Ada yang memuat STEM secara lengkap, ada pula yang menyajikan sebagian muatan STEM sesuai karakteristik mata pelajaran atau isi bacaan.
                            </p>
                            
                            <p>Murid dapat menjelajah koleksi sesuai minat dan tingkatan:</p>
                            <ul className="list-disc ml-6">
                              <li>
                                Mengenal STEM melalui cerita fiksi atau petualangan yang disisipi muatan sains, teknologi, rekayasa, atau matematika.
                              </li>
                              <li>
                                Mempelajari buku teks yang memuat STEM dari yang sederhana hingga yang kompleks.
                              </li>
                              <li>
                                Memperdalam pemahaman lintas bidang sesuai capaian pembelajaran di kurikulum.
                              </li>
                            </ul>
                            
                            <p style={{ textAlign: 'justify' }}>
                              Guru dapat memanfaatkan koleksi sebagai sarana pengayaan: menambahkan aktivitas, memperkuat muatan STEM yang ada, atau melengkapi buku dengan aspek STEM lain yang relevan. Dengan demikian, pembelajaran dapat berlangsung lebih menyenangkan, ramah, dan bermakna, sekaligus mendorong tumbuhnya minat anak pada STEM.
                            </p>
                            
                            <p style={{ textAlign: 'justify' }}>
                              Mari bersama memulai petualangan belajar STEM dengan koleksi buku ini. <br/><br/>
                              <b>Selamat memilih, membaca, dan berkreasi</b>!
                            </p>

                          </>
                        )}

                        <button 
                          onClick={toggleExpanded}
                          className="btn btn-sm btn-success rounded transition-colors duration-200"
                        >
                          {isExpanded ? 'Sembunyikan' : 'Baca Selengkapnya'}
                        </button>
                      </div>
                    </div>
                  </div>

                  <div style={{ fontSize: '16px', background: '#f0f0f0', padding: '10px', borderRadius: '5px' }}>
                    <div className="mb-3">
                      <b>Panduan pembelajaran STEM</b>
                    </div>

                    <div className="row">
                      <div className="col-md-2 col-sm-3 mb-3">
                        <img 
                          src="https://ik.imagekit.io/6ix6n7mhslj/SIBI/Screenshot%202025-09-22%20at%2014.30.29_DzSnpZHJU.png?updatedAt=1758526280280" 
                          className="img-fluid"
                          alt="Panduan Pembelajaran STEM"
                        />
                      </div>
                      <div className="col-md-10 col-sm-9">
                        <p style={{ textAlign: 'justify' }}>
                          Panduan Pembelajaran STEM disusun sebagai rujukan praktis dan inspiratif bagi pendidik di berbagai jenjang. Panduan ini memuat konsep, kerangka, strategi implementasi, dan contoh pembelajaran STEM yang dapat diadaptasi sesuai konteks satuan pendidikan.
                        </p>
                        <a 
                          target="_blank" 
                          href="https://files.cloudapp.web.id/buku/PanduanStem.pdf" 
                          className="btn btn-sm btn-success"
                        >
                          Unduh Panduan
                        </a>
                      </div>
                    </div>
                  </div>
                  
                </div>
              </div>

              <div className="border border-1 rounded p-3 mb-4 mt-3">
        
                <div className="row g-2 align-items-end">
                  {/* Tombol filter */}
                  <div className="col-md-8 d-flex gap-2">
                    <button
                      type="button"
                      className={`btn ${
                        filters.type === "semua"
                          ? "btn-primary"
                          : "btn-outline-primary"
                      }`}
                      onClick={() => handleTypeChange("semua")}
                    >
                      Semua
                    </button>
                    <button
                      type="button"
                      className={`btn ${
                        filters.type === "umum"
                          ? "btn-primary"
                          : "btn-outline-primary"
                      }`}
                      onClick={() => handleTypeChange("umum")}
                    >
                      Buku Nonteks
                    </button>
                    <button
                      type="button"
                      className={`btn ${
                        filters.type === "pelajaran"
                          ? "btn-primary"
                          : "btn-outline-primary"
                      }`}
                      onClick={() => handleTypeChange("pelajaran")}
                    >
                      Buku Teks Utama
                    </button>
                  </div>

                  {/* Search input */}
                  <div className="col-md-4">
                    <div className="input-group">
                      <input
                        id="title"
                        name="title"
                        value={filters.title}
                        onChange={(e) =>
                          setFilters({ ...filters, title: e.target.value })
                        }
                        type="text"
                        className="form-control"
                        placeholder="Cari judul..."
                      />
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={handleSearchClick}
                      >
                        <FontAwesomeIcon icon={faSearch} />
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row">
                {isLoading ? (
                  [...Array(6)].map((_, index) => (
                    <div key={index} className="col-lg-4 my-2">
                      <CardSkeleton />
                    </div>
                  ))
                ) : books.length === 0 ? (
                  <div className="text-center mt-5">
                    <img
                      width="60"
                      src="/assets/image/catalog/not-found.png"
                      className="img-fluid"
                      alt="Not found"
                    />
                    <div className="text-center mt-2">
                      Buku tidak ditemukan atau belum tersedia
                    </div>
                  </div>
                ) : (
                  books.map((book, index) => (
                    <div key={index} className="col-lg-4 my-2">
                      <Link
                        to={`/katalog/${book.slug}`}
                        className="text-decoration-none text-dark"
                      >
                        <CardBook
                          image={book.image}
                          title={book.title}
                          typeBook={"pdf"}
                          level={book.level}
                          book={book}
                        />
                      </Link>
                    </div>
                  ))
                )}
              </div>

              <div className="mt-4">
                <Paginator
                  pagePrevText={<FontAwesomeIcon icon={faArrowLeft} />}
                  pageNextText={<FontAwesomeIcon icon={faArrowRight} />}
                  totalRecords={totalRecords}
                  pageLimit={pageLimit}
                  pageNeighbours={2}
                  setOffset={setOffset}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default BukuSTEM;
